
import { defineComponent, onMounted, ref, onUnmounted, watch, reactive } from 'vue'
import { debounce } from '@/plugins/debounce'
import { getContent } from '@/api'
import { RecentCarousel } from '@/components/carousel.vue'
import { useToast } from 'vue-toastification'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default defineComponent({
  async setup () {
    const store = useStore()
    const router = useRouter()
    const scrollComponent = ref<HTMLLIElement | null>(null)
    const loading = ref(false)
    const debounceTimer = 5000
    const page = ref(1)
    const toast = useToast()
    const callMore = ref(true)
    const pageContent = reactive({ data: [] as RecentCarousel[]|null })
    watch(() => router.currentRoute.value.params.query, async (newVal) => {
      try {
        store.dispatch('loading')
        page.value = 1
        const res = await getContent(page.value, 5, newVal as string)
        pageContent.data = res.data.data
        if (res.status === 200) {
          page.value++
          callMore.value = true
          setTimeout(() => store.dispatch('loading'), 2000)
        }
      } catch (error) {
        toast.error(error.response.data.message)
        setTimeout(() => store.dispatch('loading'), 2000)
      }
    })
    const handleScroll = async () => {
      if (!callMore.value) return
      loading.value = true
      if (!scrollComponent.value) return
      const el: HTMLLIElement|null = scrollComponent.value
      if (el.getBoundingClientRect().bottom < window.innerHeight) {
        try {
          const res = await getContent(page.value, 5, router.currentRoute.value.params.query as string)
          if (res.status === 200) {
            if (!pageContent.data) return
            pageContent.data.push(...res.data.data)
            if (res.data.data.length === 0) callMore.value = false
            loading.value = false
            page.value++
          }
        } catch (error) {
          toast.error(error)
          loading.value = false
        }
      }
    }
    onMounted(() => {
      window.addEventListener('scroll', debounce(handleScroll, debounceTimer))
    })
    onUnmounted(() => {
      window.removeEventListener('scroll', debounce(handleScroll, debounceTimer))
    })
    try {
      const res = await getContent(page.value, 5, router.currentRoute.value.params.query as string)
      pageContent.data = res.data.data
      if (res.status === 200) {
        page.value++
      }
    } catch (error) {
      toast.error(error.response.data.message)
    }
    return {
      page,
      loading,
      scrollComponent,
      pageContent,
      callMore
    }
  }
})
